import { z } from 'zod'

const GenerateFunctionDocsStatus = z.object({
  progress: z.number(),
  label: z.string(),
  state: z.enum(['loading', 'success', 'error']),
})

type GenerateFunctionDocsStatus = z.infer<typeof GenerateFunctionDocsStatus>

const GenerateFunctionDocsMetadata = z.object({
  status: GenerateFunctionDocsStatus,
})

type GenerateFunctionDocsMetadata = z.infer<typeof GenerateFunctionDocsMetadata>

export type { GenerateFunctionDocsStatus }

/**
 * Parse the status from the metadata.
 *
 * Used by the `useGenerateFunctionDocs` hook to parse the status.
 *
 * SDK-free on purpose: this module must stay importable from client bundles,
 * so it never imports from `@trigger.dev/sdk` (which pulls in Node-only APIs).
 */
export function triggerParseStatus(data: unknown): GenerateFunctionDocsStatus {
  return GenerateFunctionDocsMetadata.parse(data).status
}

export function triggerParseProgress(step: number, totalSteps: number): number {
  return Math.round((step / totalSteps) * 100)
}
